/// <reference path="../../../../../WebUI/typings/tsd.d.ts" />
import * as React from "react";
import * as ReactDOM from "react-dom";
import {ProgressRingControl} from "../../../../../Intercom.ReactUI/Views/index";

export interface BotProgressProps extends React.Props<BotProgress> {
    progress?: string;
}

export class BotProgress extends React.Component<BotProgressProps, {}> {
    private mask: HTMLDivElement;

    public componentDidMount() {
        if (this.mask) {
            this.mask.focus();
        }
    }

    public render(): JSX.Element {
        return (
            <div className="status-mask progress" tabIndex={-1} ref={x => this.mask = x} onKeyDown={e => {e.preventDefault(); e.stopPropagation();}}>
                <div className="row">
                    <ProgressRingControl className='progress-large'/>
                </div>
                <p>
                    {this.props.progress || 'Provisioning your bot... This might take a few minutes.'}
                </p>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./Client/v4/Views/status/BotProgress.tsx